module.exports = __webpack_public_path__ + "static/img/shubham_photo.7daa9382.png";